// extracted by mini-css-extract-plugin
export default {"avatar":"AnimalAvatar_avatar__gyaoG","choices":"AnimalAvatar_choices__GWz3j"};